<template>
  <!-- Dialog Remove User -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="550px"
    top="8vh"
    empty-header
    @close="hideDialog"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/trash.svg')"
      :title="$t('dialogs.remove.confirmDeletion')"
      :subtitle="$t('dialogs.remove.areYouSureYouWantToDeleteIt')"
      :show-illustration="false"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :loading="loading"
        :cancel-btn-text="$t('dialogs.remove.noJustKidding')"
        :submit-btn-text="$t('dialogs.remove.yesDeleteIt')"
        space-between-buttons
        variant-button="red"
        @submit="confirm"
        @cancel="hideDialog"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Remove User -->
</template>

<script>
export default {
  name: 'DialogRemoveUser',

  props: {
    visible: {
      default: false,
      type: Boolean
    },

    hideDialog: {
      type: Function,
      default: function () {}
    },

    confirm: {
      type: Function,
      default: function () {}
    }
  },

  data () {
    return {
      loading: false
    }
  }

}
</script>
